import { TableHead as MUITableHead } from '@mui/material';
import React from 'react';
import { useStyles } from './TableHead.styles';
export function TableHead({ children, className, id }) {
    const classes = useStyles();
    return (React.createElement(MUITableHead, { classes: { root: classes.root }, className: className, id: id }, children));
}
//# sourceMappingURL=TableHead.js.map